import React from 'react';
import { observer } from 'mobx-react';
import { CellProps } from '../../stores/card/ModeExcel';
import CardStore from '../../stores/card';
import _ from 'lodash';
import * as InputUtil from '../../components/excel-layout/cell-field/input-element/wf-form-input/util'

interface ExcelTableCellDetailSumProps{
    cell: CellProps;
    form: any;
    card: CardStore;
}

/**
 * 明细合计区域
 */
@observer
export default class ExcelTableCellDetailSum extends React.Component<ExcelTableCellDetailSumProps, any> {

    render() {
        const { cell, form, card } = this.props;
        const fieldid = cell.getPath();
        const { fieldtype, qfws, detail } = card.getFieldProps(fieldid);
        const excel = card.modeExcel.getExcel(detail)
        const {detailFinancialMap}=excel;
        let showSumValue = 0;
        let fieldSumValue = 0;
        let decimals = 2;
        if (fieldtype == "2")
            decimals = 0;
        else if (fieldtype == "3" || fieldtype == "5")
            decimals = parseInt(qfws, 0);
        detail && form.$(detail).map(row => {
            if (row.has(fieldid)) {
                let value = row.$(fieldid).getValue()
                if(fieldtype ==  5){
                    // 千分位处理
                    value = delcommafy(row.$(fieldid).getValue());
                }
                let fieldValue = parseFloat(value);
                if (!!fieldValue && !isNaN(fieldValue)) {
                    fieldSumValue += fieldValue;
                    fieldSumValue = parseFloat(fieldSumValue.toFixed(decimals));
                }
            }
        });
        
        let thousands = fieldtype == "5" ? 1 : 0;
        let format = cell.format;//qc:1090545,千分位保存显示不生效问题
        if(format!==undefined){
            thousands = cell.format.thousands === "1"? 1 : 0;
        }
        const financial=_.get(detailFinancialMap,fieldid);
        if(financial=='4'){
            thousands=1;
        }
        showSumValue = FormatFloatValue(fieldSumValue, decimals, thousands);
        if(financial=='3'){
            showSumValue = InputUtil.convertAmountChinese(fieldSumValue);
        }
        return <span>{showSumValue}</span>
    }
}



export function delcommafy(num){
 
    if( (num+"").trim() == ""){
       return"";
    }
  
    num=num.replace(/,/gi,'');
  
    return num;
  
} 

export function FormatFloatValue(realval, decimals, thousands) {    
    var regnum = /^(-?\d+)(\.\d+)?$/;
    if (!regnum.test(realval)) {
        return realval;
    }
    realval = realval.toFixed(decimals).toString();
    var formatval;
    if (decimals === 0) {		//需取整
        formatval = Math.round(parseFloat(realval));
    } else {
        var n = Math.pow(10, decimals);
        formatval = Math.round(parseFloat(realval) * n) / n;
        var pindex = formatval.toString().indexOf(".");
        var pointLength = pindex > -1 ? realval.substr(pindex + 1).length : 0;	//当前小数位数
        if (decimals > pointLength) {		//需补零
            if (pindex == -1)
                formatval += ".";
            for (var i = 0; i < decimals - pointLength; i++) {
                formatval += "0";
            }
        }else if(decimals == pointLength){
            formatval=realval;
        }
    }
    formatval = formatval.toString();
    var index = formatval.indexOf(".");
    var intPar = index > -1 ? formatval.substring(0, index) : formatval;
    var pointPar = index > -1 ? formatval.substring(index) : "";
    if (thousands === 1) {				//整数位format成千分位
        var reg1 = /(-?\d+)(\d{3})/;
        while (reg1.test(intPar)) {
            intPar = intPar.replace(reg1, "$1,$2");
        }
    }
    formatval = intPar + pointPar;
    return formatval;
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/DetailSum.tsx